import { removeCookie, setCookie } from 'react-simple-cookie-store'
import { AccessToken } from './AccessToken'
import { ICredentials } from './types'

/**
 * Sets the authentication credentials in cookies
 *
 * @param credentials Object containing accessToken, refreshToken, and temporaryAccessToken
 */
export const setCredentials = ({
  accessToken,
  refreshToken,
  temporaryAccessToken,
}: ICredentials) => {
  // Handle temporary token flow
  if (temporaryAccessToken) {
    console.log('Setting temporary access token and removing other tokens')
    removeCookie(AccessToken.Access)
    removeCookie(AccessToken.Refresh)
    setCookie(AccessToken.Temporary, temporaryAccessToken, 1)
    return
  }

  // Handle main authentication flow
  if (accessToken) {
    console.log('Setting access token')
    setCookie(AccessToken.Access, accessToken, 7)
    removeCookie(AccessToken.Temporary)
  }

  if (refreshToken) {
    console.log('Setting refresh token')
    setCookie(AccessToken.Refresh, refreshToken, 7)

    // Safety check: warn if tokens are identical
    if (accessToken && refreshToken && accessToken === refreshToken) {
      console.log(
        'WARNING: Access token and refresh token are identical. This is a security risk.'
      )
    }
  }
}
